import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";

import './branches-map.scss';

//components
import AutoComplete from "../../../components/forms/autocomplete";
import Map from "../../../components/services/google/map";
import Markers from '../google/markers/markers';

//assets

import blue_phone from 'assets/icons/blue-phone.svg';
import blue_marker from 'assets/icons/blue-marker.svg';
import map_pin from 'assets/icons/blue-marker-filled.svg';
import arrow_grey from 'assets/icons/arrow-grey.svg';
import {cleanUpObject, createAnalyticsItemsList, getMediaPath} from "../../../app/functions";
import AnalyticsManager from "../../../app/analytics";


class BranchesMap extends Component{

    constructor(props){
        super(props);
        this.state = {
            city:{
                options: [],
                selected: -1,
            },
            selected_branch: -1,
            mapLoaded:false,
            isPicked: false,
            my_map:null,
            query:'',
            showErr:false,
        };

        this.cityOnChange = this.cityOnChange.bind(this);
        this.getAllBranches = this.getAllBranches.bind(this);
        this.collapseHasPressed = this.collapseHasPressed.bind(this);
        this.handleMapOnLoaded = this.handleMapOnLoaded.bind(this);
        this.queryOnChange =this.queryOnChange.bind(this);
    }

    componentDidMount(){
        const data = this.props.branches;
        let cities = parseBranches(data);
        const isPicked = cities.length < 2;
        const selected = isPicked ? 0 : -1;
        this.setState({city: {...this.state.city, options: cities, selected: selected},isPicked:isPicked});
    }

    componentDidUpdate(prevProps){
        if (prevProps.branches !== this.props.branches){

            const data = this.props.branches;
            let cities = parseBranches(data);
            const isPicked = cities.length < 2;
            const selected = isPicked ? 0 : -1;
            this.setState({city:{...this.state.city, options : cities, selected : selected},isPicked: isPicked, mapLoaded: isPicked, selected_branch: -1 });
            this.forceUpdate();
        }
    }

    collapseHasPressed(id){
        if (id === this.state.selected_branch)
            id = -1;
        this.setState({selected_branch: id});
    }


    getAllBranches(){
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';

        const data = this.props.branches;

        let res =[];

        const city = this.state.city.options.filter(item =>{
            return this.state.city.selected === item.id
        });


        for (let key in data) {
            if (this.state.city.selected !== -1) {
                if (key === city[0].text) {
                    data[key].forEach((item, index) => {
                        res.push(
                            <div key={index} className='branch-wrapper' onClick={() => this.collapseHasPressed(index, item.latitude, item.longitude)}>
                                <div className='texts'>
                                    <span className='city-span'>{item.title}</span>
                                    <div className='address-phone-wrapper'>
                                        {isLaptopOrDesktop && <img className='desktop-arrow' src={getMediaPath(arrow_grey)} alt='/'/>}
                                        {item.phone1 !== '' &&
                                        <div className='data-wrap' onClick={()=>{
                                            AnalyticsManager.logClickOnBranchPhoneNumber(createAnalyticsItemsList([{
                                                ...this.props.benefit,
                                                quantity: 1,
                                                item_variant: 'external-lead-phone'
                                            }]))
                                        }}>
                                            <img src={getMediaPath(blue_phone)} alt='/'/>
                                            <span className='data-span'> {item.phone1}</span>
                                        </div>
                                        }
                                        <div className='data-wrap branch-address' onClick={()=>{
                                            AnalyticsManager.logClickOnBranchAddress(createAnalyticsItemsList([{
                                                ...this.props.benefit,
                                                quantity: 1,
                                                item_variant: 'external-lead-navigation'
                                            }]))
                                        }}>
                                            <img src={getMediaPath(blue_marker)} alt='/'/>
                                            <span className='data-span'>{item.fullAddress}</span></div>
                                    </div>
                                </div>

                                { !isLaptopOrDesktop &&
                                    <div className='waze-intent'>
                                        <a className='link'
                                           href={'https://waze.com/ul?ll=' + item.latitude + '%2C' + item.longitude + '&navigate=yes&zoom=17'}>למפת
                                            הגעה</a>
                                    </div>
                                }
                                {item?.hours &&  Object.keys(item?.hours).length > 0 &&
                                <div className='hours-container'>
                                    <span className='hours-title'>{this.props.text['benefit_map_opening_hours']}</span>
                                    {
                                        Object.keys(item?.hours).map((key) => {
                                            return <div className='hour' key={ key }>
                                                <span>{key + " : "}</span>
                                                <span>{item?.hours[key].openHour + ' - ' + item.hours[key].closeHour}</span>
                                            </div>
                                        })
                                    }
                                </div>
                                }
                            </div>
                        )
                    });
                }
            }
        }

        return res;
    }

    cityOnChange(id){
        const city = this.state.city.options.filter(item =>{
            return id === item.id
        });

        this.setState({city:{...this.state.city, selected : id},isPicked: true, selected_branch: -1, query:city[0].text});
    }

    setMarkersData(){
        const branches = this.props.branches;
        let markers = [];

        const city = this.state.city.options.filter(item =>{
            return this.state.city.selected === item.id
        });

        for (let key in branches){
            if (this.state.city.selected !== -1) {
                if (key === city[0].text) {
                    branches[key].forEach((item,index)=> {
                        markers.push(
                            {
                                benefit: item,
                                id:index,
                                location: new window.google.maps.LatLng(item.latitude, item.longitude),
                                mapPin: {url: map_pin, scaleSize: new window.google.maps.Size(20, 27)},
                                handlePinOnClick: () => {
                                },
                            })
                    })
                }
            }
        }

        return markers;
    }

    handleMapOnLoaded(){
        this.setState({mapLoaded: true, my_map : window.my_map});
    }

    queryOnChange(e){
        const city = e.target.value;

        //check if the string is sub string of some city
        const cities = this.state.city.options.filter(item =>{
           return item.text.includes(city);
        });

        this.setState({query: e.target.value, showErr:cities.length < 1});
    }

    render(){

        return(
            <section className='branches'>
                <div className='details'>
                    <h3 className='title'>{this.props.text['benefit_map_title']}</h3>
                    <div className='auto-wrap'>
                        <AutoComplete deviceState={'desktop'}
                                      className={'auto-branch'}
                                      options={this.state.city.options}
                                      onSelect={this.cityOnChange}
                                      onChange={this.queryOnChange}
                                      query={this.state.query}
                                      placeholder={this.state.query !== '' ? this.state.query : this.props.text['benefit_map_placeholder']}
                                      onClear={() => {
                                          this.setState({query: ''})
                                      }}
                        />
                        {this.state.showErr && <span className='no-branch'>לא נמצא סניף בעיר הזאת</span>}
                    </div>


                    <div className='branches-container'>
                        {this.getAllBranches()}
                    </div>
                </div>
                <div className='map'>
                    {this.state.city.options && this.state.isPicked &&
                    <Fragment>
                        <Map apiKey={window.googleMapsApiKey}
                             id={'branches-map'}
                             onMapLoad={this.handleMapOnLoaded}
                             onMapUnload={() => {
                             }}
                             onClusterLoad={() => {
                             }}
                             options={{
                                 zoom: 14,
                                 center: {lat: 32.062510, lng: 34.778832},
                                 zoomControl: true,
                                 mapTypeControl: false,
                                 scaleControl: false,
                                 streetViewControl: false,
                                 rotateControl: false,
                                 fullscreenControl: false,
                                 clickableIcons: false
                             }}
                        />
                        {this.state.mapLoaded &&
                        <Markers mapID={'benefits-map'} data={this.setMarkersData()}
                                 handleMapOnClick={() => {
                                 }}
                                 constantlyUpdate={true}
                                 selected ={this.state.selected_branch !== -1 ? this.state.selected_branch : false}
                        />
                        }
                    </Fragment>
                    }
                </div>
            </section>
        )
    }
}


function parseBranches(branches) {
    const data = branches;
    let cities = [];

    let id = 0;
    for(let key in data){
        cities.push({text:key,id:id ++});
    }

    return cities;
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        benefitTypes: cleanUpObject(store.config.IconTypes),
        text: store.config.Translations,
    }
};

const mapDispatchToProps = dispatch => {
    return {
    }
};


export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(BranchesMap);
